import {
    DOCUMENT_SOURCE_ADDITIONAL,
    DOCUMENT_SOURCE_APPLICATION,
    GET_APPLICATION_DOCUMENTS,
    get_headers,
    REQUEST_INFO_URL,
    UPLOAD_ADDITIONAL_DOCUMENTS,
    VERIFY_ADDITIONAL_DOCUMENT_URL,
    VERIFY_DOCUMENT_URL,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';


export default {
    name: 'DocumentManagement',
    mixins: [alert_mixin, formatting_mixins],
    emits: ['files-saved'],
    props: {
        application_form_id: { type: [String, Number], default: null },
    },

    data: () => ({
        headers: get_headers(),
        documents: [],
        selected_document: null,
        table_safe_documents: [],
        preview_url: null,
        answered_file_questions: [],
        request_info_note: "",
        selected_request_fields: [],
        attachments: [
            {
                document_name: '',
                file: null
            }
        ],
        application_id: null,
        preview_modal: false,
        is_uploading_documents: false,
    }),
    mounted() {
        this.application_id = sessionStorage.getItem('application_id');
        if (this.application_id) {
            this.get_documents();
        }
    },

    watch: {
        profile_role_form_id(newVal) {
            if (newVal) {
                this.get_documents();
            }
        }
    },

    computed: {
        has_unverified_documents() {
            return this.table_safe_documents.some(doc => !doc.is_verified);
        }
    },

    methods: {
        select_document(doc) {
            this.selected_document = doc;
        },




        get_documents() {
            this.documents = [];
            axios.get(GET_APPLICATION_DOCUMENTS, {
                headers: this.headers,
                params: { application_id: this.application_id }
            })
                .then(response => {
                    const parsed_response = response.data;

                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.documents = parsed_response.data;
                        this.transform_documents_data();
                    } else {
                        this.documents = [];
                    }
                })
                .catch(error => {
                    this.show_error("Error loading documents: " + (error.response?.data?.message || error.message));
                });
        },

        transform_documents_data() {
            if (this.documents.length > 0) {
                const TABLE_DOC_DATA = this.documents.map((document, index) => ({
                    no: index + 1,
                    file_name: document.file_name,
                    section: document.section,
                    submitted_on: document.submitted_on,
                    presigned_url: document.presigned_url,
                    status: document.is_verified ? 'Verified' : 'Pending Verification',
                    is_verified: document.is_verified,
                    section_question_id: document.section_question_id,
                    verification_comment: document.verification_comment,
                    date_verified: this.format_date(document.date_verified),
                    question_id: document.question_id,
                    section_id: document.section_id,
                    question_text: document.question,
                    id: document.id,
                    source: document.source,
                }));

                this.table_safe_documents = TABLE_DOC_DATA;
            } else {
                this.table_safe_documents = [];
            }
        },

        toggle_requested_field(event, question) {
            const field = {
                form_section_id: question.section_id,
                form_section_name: question.section,
                question_id: question.question_id,
                requested_field_id: question.question_id,
                requested_field_text: question.question_text
            };

            const exists = this.selected_request_fields.some(
                item => item.requested_field_id === field.requested_field_id
            );

            if (event.target.checked && !exists) {
                this.selected_request_fields.push(field);
            } else if (!event.target.checked && exists) {
                this.selected_request_fields = this.selected_request_fields.filter(
                    item => item.requested_field_id !== field.requested_field_id
                );
            }
        },

        add_attachment() {
            this.attachments.push({ document_name: "", file: null });
        },

        remove_attachment(index) {
            this.attachments.splice(index, 1);
        },

        handle_file_upload(event, index) {
            const file = event.target.files[0];
            if (file && file.size <= 5 * 1024 * 1024) {
                this.attachments[parseInt(index, 10)].file = file;
            } else {
                this.show_error("Invalid file type or size exceeds 5MB.");
            }
        },

        upload_additional_documents() {

    this.is_uploading_documents = true;

    const formData = new FormData();
    formData.append("application_id", this.application_id);

    this.attachments.forEach((att) => {
        if (att.file) {
            formData.append("files", att.file);
            formData.append("document_names", att.document_name);
        }
    });

            axios
                .post(UPLOAD_ADDITIONAL_DOCUMENTS, formData, {
        headers: { ...this.headers, "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
        this.show_success(response.data.message || "Documents uploaded successfully!");
        this.$emit('files-saved')
        this.close_modal('upload_additional_documents_modal');

    })
    .catch((error) => {
        this.show_error(
            error.response?.data?.message || "Failed to upload additional. Please try again."
        );
    })
    .finally(() => {
        this.is_uploading_documents = false;
    });
},


        preview_file(presigned_url) {
            if (!presigned_url) {
                this.show_error("Preview URL is missing.");
                return;
            }

            this.preview_url = presigned_url;
            this.preview_modal = true;

        },
        download_file(url, file_name) {
            if (!url) {
                this.show_error("Download URL is missing.");
                return;
            }

            const downloadUrl = url

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', file_name || 'document.pdf');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        open_request_modal() {
            this.request_info_note = "";
            this.selected_request_fields = [];

            this.answered_file_questions = this.table_safe_documents.filter(doc => !doc.is_verified && doc.file_name && doc.question_id && doc.section);
        },



        validate_request_information_inputs() {
            if (!this.request_info_note.trim()) {
                this.show_error("Please enter a note.");
                return false;
            }
            if (this.selected_request_fields.length === 0) {
                this.show_error("Please select at least one field.");
                return false;
            }
            return true;
        },




        async request_information() {
            if (!this.validate_request_information_inputs()) return;

            const application_form_id = this.application_form_id
            var message = this.request_info_note;
            var requested_fields = this.selected_request_fields

            const data = {
                application_form_id: application_form_id,
                message: message,
                requested_fields: requested_fields,
            };

            axios.post(REQUEST_INFO_URL, data, {
                headers: this.headers
            })
                .then(response => {
                    const response_data = response.data;

                    if (response_data.status === 'success') {
                        this.close_modal('request_information')
                        this.show_success("Information successfully requested")
                    } else {
                        this.show_error('Error during the form submit');
                        this.close_modal('create_trust_type');
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.show_error(error.response.data.message);
                    }
                });
        },



        verify_document(row) {
            switch (row.source) {
                case DOCUMENT_SOURCE_APPLICATION:
                    this.verify_application_documents(row);
                    break;
                case DOCUMENT_SOURCE_ADDITIONAL:
                    this.verify_additional_documents(row);
                    break;
            }
        },

        verify_application_documents(row) {
            const payload = {
                is_verified: true,
                application_form_id: this.application_form_id,
                section_id: row.section_id,
                question_id: row.section_question_id,
                verification_comment: ''
            };

            axios.post(VERIFY_DOCUMENT_URL, payload, { headers: this.headers })
                .then(() => {
                    this.show_success("Document verified successfully");
                    this.get_documents();
                })
                .catch(error => {
                    this.show_error("Verification failed: " + (error.response?.data?.message || error.message));
                });
        },

        verify_additional_documents(row) {
            const payload = {
                is_verified: true,
                additional_document_id: row.id,
                verification_comment: ''
            };

            axios.post(VERIFY_ADDITIONAL_DOCUMENT_URL, payload, { headers: this.headers })
                .then(() => {
                    this.show_success("Document verified successfully");
                    this.get_documents();
                })
                .catch(error => {
                    this.show_error("Verification failed: " + (error.response?.data?.message || error.message));
                });
        },

    }
};